import { Span } from "@goodfill/ui-components";
import { InfoTooltip } from "../ui-components/tooltip/InfoTooltip";
import { Fragment } from "react";

interface Props {
  validation: React.ReactNode[];
  className?: string;
  tooltip?: boolean;
}

export const FormValidationComponent = ({ validation, className, tooltip }: Props) => {
  if (validation.length === 0) {
    return null;
  }

  if (tooltip === true) {
    return (
      <InfoTooltip
        intent="danger"
        text={validation.map((element, i) => (
          <Fragment key={i}>
            {element}
            <br />
          </Fragment>
        ))}
        verticalOffset="4px"
      />
    );
  }

  return (
    <Span wrap className={className} red={true}>
      {validation.map((element, i) => (
        <Fragment key={i}>
          {element}
          <br />
        </Fragment>
      ))}
    </Span>
  );
};
